import { useEffect, useState } from "react";
import MobileLayout from "./mobile-components/Components/mobileLayout";
import DesktopLayout from "./desktop-components/Components/desktopLayout";

export default function ResponsiveLayout() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
   useEffect(()=> {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }
    window.addEventListener("resize", handleResize);
    return () =>window.removeEventListener('resize', handleResize);
   }, []); 

  return isMobile ? <MobileLayout /> : <DesktopLayout />;
}

